import { withHandlers } from 'recompose';
import { reduce } from 'ramda';

export const memoizeHandlers = (...handlerNames) =>
  withHandlers(
    reduce(
      (acc, name) => ({
        ...acc,
        [name]: (props) => props[name],
      }),
      {},
      handlerNames,
    ),
  );
